/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_View_Plan_BodyInputs */

const en_platform_view_plan_body = /** @type {(inputs: Platform_View_Plan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clients tick off sessions. You see the whole month before you ask how it's going.`)
};

const pl_platform_view_plan_body = /** @type {(inputs: Platform_View_Plan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podopieczny odhacza treningi. Ty widzisz cały miesiąc, zanim zapytasz, jak idzie.`)
};

/**
* | output |
* | --- |
* | "Clients tick off sessions. You see the whole month before you ask how it's going." |
*
* @param {Platform_View_Plan_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_view_plan_body = /** @type {((inputs?: Platform_View_Plan_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_View_Plan_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_view_plan_body(inputs)
	return en_platform_view_plan_body(inputs)
});